
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/collectible/[slug]",
      function () {
        return require("private-next-pages/collectible/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/collectible/[slug]"])
      });
    }
  